import { PortalUser, Role } from './types';

// If global user returns global user role for principal (if present) else global user role
// If not global user returns regular user role for principal
export const extractRoleFromUser = (
  currentUserSelectedPrincipal: string,
  portalUser: PortalUser | undefined,
): Role | undefined => {
  if (!portalUser) return;
  const { global_user, ...user } = portalUser;
  if (global_user) {
    const principalRoles = global_user.principalRoles;
    if (principalRoles?.[currentUserSelectedPrincipal])
      return principalRoles[currentUserSelectedPrincipal];
    if (global_user.role) return global_user.role;
    return;
  }
  return user.roles?.[currentUserSelectedPrincipal];
};
